import { SlideConfig, FormData } from '../types';

/**
 * Mapping da slide ID a benefit config key
 * Slide removed: install_timeline and decision_stage
 */
export const SLIDE_TO_BENEFIT_KEY: Record<string, string> = {
  name_form: 'name_form',
  email_form: 'email_form',
  phone_form: 'phone_form',
};

/**
 * Configurazione delle slide del wizard SliderAllBonusShort
 * 
 * SHORT VERSION: CAP slide is first, removed install_timeline and decision_stage
 * 
 * Slide types:
 * - SINGLE_ANSWER: Selezione singola con griglia di opzioni
 * - FORM_INPUT: Form con input fields
 * - INFO: Slide informativa (loading, success, error)
 */
export const SLIDES_CONFIG: SlideConfig[] = [
  // ============================================
  // SLIDE 1: Form CAP con feedback (MOVED TO FIRST POSITION)
  // ============================================
  {
    id: 'location_form',
    type: 'FORM_INPUT',
    title: 'Scopri gli incentivi e bonus nella tua zona',
    inputs: [
      {
        name: 'zip',
        placeholder: 'Inserisci il tuo CAP',
        type: 'tel',
        required: true,
        pattern: '^\\d{5}$',
        maxLength: 5,
      },
    ],
  },

  // ============================================
  // SLIDE 2: Selezione prodotto
  // ============================================
  {
    id: 'customer_type',
    type: 'SINGLE_ANSWER',
    title: 'Per quale prodotto vuoi scoprire i bonus?',
    apiFieldName: 'product_type',
    autoAdvance: true,
    answers: [
      {
        label: 'Fotovoltaico',
        value: 'Photovoltaic',
        image: 'https://uploads-ssl.webflow.com/62da8209945d9e1b7e7daf07/65a690341ab4c8ae3331bda7_IT_Slider_Icons_fotovoltaico.svg',
      },
      {
        label: 'Pompa di Calore',
        value: 'Heatpump',
        image: 'https://uploads-ssl.webflow.com/62da8209945d9e1b7e7daf07/65a69034ad376843aacab5d2_IT_Slider_Icons_pompa_di_calore.svg',
      },
      {
        label: 'Fotovoltaico + Pompa di Calore',
        value: 'Photovoltaic + Heatpump',
        image: 'https://cdn.prod.website-files.com/6621fcb456e6148dbbc48ea9/6621fcb456e6148dbbc490ee_IT_Slider_Icons_fotovoltaico_con_pompa_di_calore.svg',
      },
    ],
  },

  // ============================================
  // SLIDE 3: Tipo edificio
  // ============================================
  {
    id: 'house_type',
    type: 'SINGLE_ANSWER',
    title: 'Per quale tipo di edificio vuoi scoprire i bonus?',
    apiFieldName: 'house_type',
    autoAdvance: true,
    answers: [
      {
        label: 'Casa unifamiliare',
        value: 'detached_house',
        image: 'https://uploads-ssl.webflow.com/62da8209945d9e1b7e7daf07/65a690347c3338223a5c8d5d_IT_Slider_Icons_casa_unifamiliare.svg',
      },
      {
        label: 'Casa a schiera',
        value: 'townhouse',
        image: 'https://uploads-ssl.webflow.com/62da8209945d9e1b7e7daf07/65a69035fd81055cfcf886db_IT_Slider_Icons_casa_a_schiera.svg',
      },
      {
        label: 'Condominio (più di 6 famiglie)',
        value: 'multi_family_house',
        image: 'https://cdn.prod.website-files.com/6621fcb456e6148dbbc48ea9/672101f43a7562ecc9146c47_IT_Slider_Icons_Condominio.svg',
      },
      {
        label: 'Palazzina (fino a 6 famiglie)',
        value: 'small_building',
        image: 'https://cdn.prod.website-files.com/6621fcb456e6148dbbc48ea9/672101f39fd017299f37df74_IT_Slider_Icons_Copropriet%C3%A0.svg',
      },
      {
        label: 'Edificio industriale / Capannone',
        value: 'commercial_building',
        image: 'https://uploads-ssl.webflow.com/62da8209945d9e1b7e7daf07/65a69035e97d173f90bee987_IT_Slider_Icons_edificio_commerciale.svg',
      },
      {
        label: 'Pergolati & Altro',
        value: 'other',
        image: 'https://cdn.prod.website-files.com/6621fcb456e6148dbbc48ea9/672101f3dffe24cc4b89bb48_IT_Slider_Icons_Pergolati%20e%20altro.svg',
      },
    ],
  },

  // ============================================
  // SLIDE 4: Form Nome (BENEFICIO 1/N - dinamico)
  // ============================================
  {
    id: 'name_form',
    type: 'FORM_INPUT',
    title: '',
    header: {
      savingsSubText: '', // Valore dinamico dal conteggio bonus
      savingsText: '', // Valore dinamico dal database CAP
      indicator: { label: '' },
    },
    inputs: [
      {
        name: 'name',
        placeholder: 'Nome e cognome',
        type: 'text',
        required: true,
      },
    ],
  },

  // ============================================
  // SLIDE 5: Form Email (BENEFICIO 2/N - dinamico)
  // ============================================
  {
    id: 'email_form',
    type: 'FORM_INPUT',
    title: '',
    header: {
      savingsSubText: '', // Valore dinamico dal conteggio bonus
      savingsText: '', // Valore dinamico dal database CAP
      indicator: { label: '' },
    },
    inputs: [
      {
        name: 'email',
        placeholder: 'Il tuo indirizzo email',
        type: 'email',
        required: true,
      },
    ],
  },

  // ============================================
  // SLIDE 6: Form Telefono (BENEFICIO 3/N - dinamico)
  // ============================================
  {
    id: 'phone_form',
    type: 'FORM_INPUT',
    title: '',
    header: {
      savingsSubText: '', // Valore dinamico dal conteggio bonus
      savingsText: '', // Valore dinamico dal database CAP
      indicator: { label: '' },
    },
    inputs: [
      {
        name: 'phone',
        placeholder: 'Numero di cellulare',
        type: 'tel',
        required: true,
        pattern: '^[\\d\\s+]{8,20}$',
      },
    ],
  },

  // ============================================
  // SLIDE 7: Loading
  // ============================================
  {
    id: 'loading',
    type: 'INFO',
    title: 'Invio della richiesta in corso...',
    html: '<p>Attendere prego...</p>',
  },

  // ============================================
  // SLIDE 8: Success
  // ============================================
  {
    id: 'success',
    type: 'INFO',
    title: '',
  },

  // ============================================
  // SLIDE 9: Error
  // ============================================
  {
    id: 'error',
    type: 'INFO',
    title: 'Oops, qualcosa è andato storto',
    html: '<p>Si è verificato un errore...</p>',
  },
];

/**
 * Trova l'indice di una slide per ID
 */
export const getSlideIndexById = (id: string): number => {
  return SLIDES_CONFIG.findIndex((slide) => slide.id === id);
};

/**
 * Slide IDs che mostrano benefici dinamici (hanno header)
 * SHORT VERSION: Only 3 benefit slides
 */
export const BENEFIT_SLIDE_IDS = [
  'name_form',
  'email_form',
  'phone_form',
] as const;

/**
 * Slide IDs per il calcolo del progresso
 */
export const PROGRESS_SLIDE_IDS = SLIDES_CONFIG
  .filter((slide) => slide.type === 'SINGLE_ANSWER' || slide.type === 'FORM_INPUT')
  .map((slide) => slide.id);

/**
 * Ottiene la chiave del beneficio per un dato slide ID
 */
export function getBenefitKeyForSlide(slideId: string): string {
  return SLIDE_TO_BENEFIT_KEY[slideId] || slideId;
}

/**
 * Ottiene il nome breve del beneficio per il testo del bottone CTA
 */
export function getBenefitShortName(benefitText: string | null): string {
  if (!benefitText) return 'il prossimo Beneficio';

  const text = benefitText.toLowerCase();

  if (text.includes('bolletta')) return 'il Risparmio in Bolletta';
  if (text.includes('surplus')) return 'il Surplus CER';
  if (text.includes('rivendita') && !text.includes('surplus')) return 'la Rivendita Energia';
  if (text.includes('ecobonus')) return "l'Ecobonus";
  if (text.includes('pnrr') || text.includes('cer enpal')) return 'il PNRR CER Enpal';
  if (text.includes('conto termico')) return 'il Conto Termico';
  if (text.includes('bonus regione fvg')) return 'il Bonus Regione FVG';
  if (text.includes('risparmio totale')) return 'il Risparmio Totale';

  return 'il prossimo Beneficio';
}
